import { render, staticRenderFns } from "./EquityChanges.vue?vue&type=template&id=57816ba4&scoped=true"
import script from "./EquityChanges.vue?vue&type=script&lang=js"
export * from "./EquityChanges.vue?vue&type=script&lang=js"
import style0 from "./EquityChanges.vue?vue&type=style&index=0&id=57816ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57816ba4",
  null
  
)

export default component.exports